<template>
    <div class="slider-component">
        <div class="header-wrap">
            <el-card class="app-table-container" :body-style="{ padding: '20px' }">
                <div class="header-content">
                    <p>{{$t('content.store.bannerPreview')}}</p>
                    <el-carousel indicator-position="outside" height='160px'>
                        <el-carousel-item v-for="item in 4" :key="item">
                            <!-- <h3>{{ item }}</h3> -->
                        </el-carousel-item>
                    </el-carousel>                    
                    <!-- <ul>
                        <li>logo</li>
                        <li v-for="n in 6" :key="n">分类</li>
                    </ul> -->
                </div>
            </el-card>
        </div>
        <div class="app-table-container body-wrap">
            <el-row :gutter="20">
                <el-col :span="12">
                    <DataTable
                    tableId="table-first"
                    :tableProps="selectedProps"
                    :tableData="selectedData"
                    :tableTitle="$t('content.store.bannerSelected')"
                    @tableHandle="selectedHandle"
                    >
                    <!-- <pagination
                    layout="prev, pager, next"
                    :pageSize='selectedParams.limit'
                    :total="selectedTotal"
                    @pageNum="selectPageNum"                            
                    /> -->
                    </DataTable>
                </el-col>
                <el-col :span="12">
                    <DataTable
                    tableId="table-second"
                    :tableProps="selectableProps"
                    :tableData="selectableData"
                    :tableTitle="$t('content.store.bannerSelected')"
                    @tableHandle="selectableHandle"
                    >
                    <!-- <pagination
                    layout="prev, pager, next"
                    :pageSize='selectableParams.limit'
                    :total="selectableTotal"
                    @pageNum="selectablePageNum"
                    /> -->
                    </DataTable>
                </el-col>
            </el-row>
        </div>
        <div class="footer-wrap">
            <button class="global-button-style">{{$t('commonMsg.save')}}</button>
            <button class="global-button-style">{{$t('content.store.addBanner')}}</button>
        </div>      
    </div>
</template>

<script>
import DataTable from '@/components/dataTable'
export default {
    components: {
        DataTable
    }, 
    computed: {
        selectedProps() {
            const selectedProps = [{
                prop: 'slider',
                label: this.$t('content.store.bannerTitle')
            },{
                prop: 'name',
                label: this.$t('content.store.bannerName')
            },{
                prop: 'move',
                label: this.$t('content.store.bannerMove')
            },{
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                width: 80,
                btn: [this.$t('commonMsg.del')]
            }]
            return selectedProps
        },
        selectableProps() {
            const selectableProps = [{
                prop: 'slider',
                label: this.$t('content.store.bannerTitle')
            },{
                prop: 'name',
                label: this.$t('content.store.bannerName')
            },{
                prop: 'link',
                label: this.$t('content.store.bannerLink')
            },{
                prop: 'handle',
                label: this.$t('commonMsg.handle'),
                width: 80,
                btn: [this.$t('commonMsg.add')]
            }]

            return selectableProps
        }
    },
    data() {
        return {           
            selectedData: [
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },
                {
                    name: '大优惠',
                    link: 'http://send2boox'                    
                },                                                                                                                                                                                
            ],
            selectableData: [],
            selectedTotal: 0,
            selectableTotal: 0,
            selectedParams: {limit: 20, offset: 0},
            selectableParams: {limit: 20, offset: 0}
        }
    }, 
    methods: {
        selectedHandle(value){
            this.selectedData.splice(value.data.$index, 1)
            this.selectableData = [...this.selectableData, value.data.row]
        },   
        selectableHandle(value){
            // let isTure = this.selectedData.some(item => value.data.row.id === item.id)
            this.selectableData.splice(value.data.$index, 1)
            this.selectedData = [...this.selectedData, value.data.row]
        }             
    },      
    created() {
    }
}
</script>

<style lang="scss">
    .slider-component{    
        flex: 1;
        display: flex;
        flex-direction: column;
        .header-wrap{
            // min-height: 200px;
            .app-table-container{
                margin-bottom: 0;
                .header-content{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    p{
                        margin-bottom: 10px;
                        font-size: 20px;
                        font-weight: bold;
                    }
                    .el-carousel{
                        width: 500px;
                    }

                    .el-carousel__item:nth-child(2n) {
                        background: repeating-linear-gradient(90deg, white 20px, pink 40px, gray 60px, blue 80px, purple 100px);
                    }

                    .el-carousel__item:nth-child(2n+1) {
                        background: repeating-linear-gradient(0deg, white 20px, pink 40px, gray 60px, blue 80px, purple 100px);
                    }
                }
            }
        }
        .body-wrap{
            flex: 1;
        }
        .footer-wrap{
            margin-bottom: 20px;
            text-align: center;
        }
    }
</style>